// extracted by mini-css-extract-plugin
module.exports = {"products":"index_products__sQpDD"};